import supabase from 'supabase';
import { Dispatch } from 'redux';
import BIO_TYPES from './types';

export const getBio =
  () =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(BIO_TYPES.bioStart());

    const { data, error } = await supabase.from('bio').select();

    if (data?.length) dispatch(BIO_TYPES.bioSuccess(data));
    else if (error) dispatch(BIO_TYPES.bioError(error.message));
  };

export const updateBio =
  (id: number, title: string, desc: string, title2: string, desc2: string, title3: string) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(BIO_TYPES.bioStart());

    const { data, error } = await supabase
      .from('bio')
      .update({ title, desc, title2, desc2, title3 })
      .eq('id', id)
      .select();

    if (data?.length) dispatch(BIO_TYPES.bioSuccess(data));
    else if (error) dispatch(BIO_TYPES.bioError(error.message));
  };
